import { ValueOf } from '@/types/util';

export const companyStatus = {
  WAITING: '有効待ち',
  AVAILABLE: '有効',
  CLOSED: '終了',
  SMART_CODE_WAITING: 'SC有効待ち',
  SMART_CODE_AVAILABLE: 'SC有効',
} as const;

export type CompanyStatusKey = keyof typeof companyStatus;
export type CompanyStatusValue = ValueOf<typeof companyStatus>;

export const companyStatusKeys = Object.keys(companyStatus) as CompanyStatusKey[];

/** v-select用items */
export const companyStatusItems = companyStatusKeys
  .map((key) => ({
    title: companyStatus[key],
    value: key,
  }));
